import Swiper, {Navigation, Autoplay, Pagination} from "swiper";
import "swiper/scss";

class NewsByTagSlider {
    constructor() {

        this.newsSlider = new Swiper('.news-slider.news-slider--tag .news-js', {
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            modules: [Navigation, Autoplay, Pagination],
            direction: "horizontal",
            scrollbar: false,
            slidesPerView:1,
            spaceBetween: 28,
            loop: true,
            navigation: {
                prevEl: ".news-slider.news-slider--tag .news-slider__next--prev",
                nextEl: ".news-slider.news-slider--tag .news-slider__next--next"
            },
            pagination: {
                el: ".news-slider__dots",
                type: "bullets",
                bulletElement: "div",
                bulletClass: "news-slider__dot",
                bulletActiveClass: "news-slider__dot--active",
                clickable: true,
            }
        })
    }
}

export default NewsByTagSlider;